import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => ({
    container: {
        position: 'absolute',
        left: '10px',
        bottom: '40px',
        zIndex: 9999,
        maxHeight: 'calc(100% - 20px)',
        overflowY: 'auto',
        '::-webkit-scrollbar': {
            display: 'none'
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        width: '400px',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        padding: theme.spacing(0.5),
    },
    chip: {
        zIndex: 2001,
        backgroundColor: theme.palette.background.paper,
        ':hover': {
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(40, 40, 40, 1)' : theme.palette.background.default,
            borderColor: theme.palette.mode === 'dark' ? 'rgba(12, 12, 12, 0.4)' : undefined
        },
        border: `${theme.spacing(0.2)} solid ${theme.palette.divider}`,
        boxShadow: theme.palette.mode === 'light' ? `0 0 8px rgba(0,0,0,0.05), 2px 2px 8px rgba(0,0,0,0.05)` : ''
    },
    close: {
        height: '24px',
        width: '24px',
        zIndex: 2001,
        backgroundColor: theme.palette.background.paper,
        ':hover': {
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(40, 40, 40, 1)' : theme.palette.background.default,
            borderColor: theme.palette.mode === 'dark' ? 'rgba(12, 12, 12, 0.4)' : undefined
        },
        border: `${theme.spacing(0.2)} solid ${theme.palette.divider}`,
        boxShadow: theme.palette.mode === 'light' ? `0 0 8px rgba(0,0,0,0.05), 2px 2px 8px rgba(0,0,0,0.05)` : ''
    },
    chipContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        position: 'relative',
        top: '20px',
        zIndex: 2000,
        right: '5px'
    },
    subHeader: {
        width: '100%',
        minHeight: '20px',
        position: 'relative',
        zIndex: 2000,
        display: 'flex',
        justifyContent: 'end'
    },

    chipLabel: { display: 'flex', gap: 1, alignItems: 'center' },

    chipAvatar: { fontSize: '12px', width: '18px', height: '18px', backgroundColor: theme.palette.text.primary },

    itemsContainer: {
        position: 'relative', 
        width: '100%', 
        height: '100px'
    },
    item1: {
        position: 'absolute', top: 0, width: '100%', zIndex: 999
    },

    item2: {
        position: 'absolute', top: '5px', left: '5%', width: '90%', zIndex: 990
    },

    item3: {
        position: 'absolute', top: '10px', left: '10%', width: '80%', zIndex: 980
    }

}))

